// Définitions UNIQUES des métriques d'appel — alignées sur le dictionnaire hook-brain (§2).
// Composés = toutes les lignes call_logs · Connecté = décroché par un humain · Conversation = connecté > 30 s.
//
// POURQUOI LE FILTRE STATUS EST OBLIGATOIRE : depuis la chaîne directe (30/09), call_logs reçoit
// TOUS les appels composés. Une durée > 0 n'implique plus « décroché » (un voicemail a une durée).
// Les formules historiques (duration > 0 = connecté, > 30 s = conversation) gonflaient les
// compteurs jusqu'à +85 % (audit 08/10 : Velatir 1248 affichés vs 674 réels).
//
// Toute nouvelle lecture de call_logs DOIT passer par ces helpers (ou leur équivalent SQL :
// status = 'connected' / status = 'connected' AND duration_seconds > 30).

export interface CallLike {
  status?: string | null;
  duration_seconds?: number | null;
}

/** Appel décroché par un humain. */
export const isConnected = (c: CallLike): boolean => c.status === 'connected';

/** Conversation = appel décroché de plus de 30 secondes (dico §2). */
export const isConversation = (c: CallLike): boolean =>
  isConnected(c) && (c.duration_seconds ?? 0) > 30;

/** Messagerie vocale. */
export const isVoicemail = (c: CallLike): boolean => c.status === 'voicemail';
